export default {
  newDesign: true,
  parameters: {
    landing_id: "SpLquizTCT",
    segment: 14,
    success_page: 'success_long',
    timer: {
      duration: 7 * 60,
      dangerTime: 60,
    },
  },
  title: "Cursos de programación para niños de 8 a 17 años | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  startPage: {
    title:
      "Responde las preguntas para inscribirte en tu primera clase de prueba.",
    subtitle:
      "Transformamos la pasión por la tecnología en una ventaja:<br>💬 Descubre los talentos de tu hijo de forma divertida<br>🌐 Solo necesitas una computadora y conexión a internet<br>🔥 Ya son más de 270 niños inscritos solo hoy",
    image: {
      url: "/welcome/sp_longquiz_dev_v2_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/sp_longquiz_dev_v2_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " ¡Empecemos! 🔥 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
  },
  customStopPages: {
    child: {
      title: "Lamentablemente, solo un padre o tutor puede inscribir a un estudiante en las clases.",
      subtitle:
        "Si quieres continuar, puedes compartir este enlace con tus padres.<br>¡Ojalá podamos verte pronto en nuestras clases! ",
      image: "/welcome/quizV2/child-parent.png",
    },
  },
  quizRotateBySteps: {
    1: {
      question: "¿Eres mamá, papá, otro familiar o hijo/a?",
      answers: [
        "Soy papá 👨‍🦱",
        "Soy mamá 👩‍🦰",
        "Soy otro familiar / tutor 👵",
        {
          answer: "Soy hijo/a 👧🧒",
          stopAnswer: true,
          customStopPageId: "child",
        },
      ],
    },
    2: {
      title: "¿Cuántos años tiene tu hijo?",
      type: "age",
      button: "",
    },
    3: {
      question: "¿Qué le gusta hacer a tu hijo en su tiempo libre?",
      answers: [
        "Jugar deportes o juegos al aire libre ⚽",
        "Leer libros o cómics 📚",
        "Ver TV, YouTube o jugar videojuegos 🎮",
        "Pasar tiempo con amigos o familiares 👫",
        "Otro 🙂"
      ],
    },
    4: {
      question: "¿Cómo se siente tu hijo con respecto al aprendizaje en línea?",
      answers: [
        "Les encanta y lo encuentran interesante 💻",
        "Prefieren el aprendizaje presencial 🙂",
        "Le cuesta mantener la concentración 😵‍💫",
        "Nunca han intentado aprender en línea ❓"
      ],
    },
    5: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/fwd_freetc_latam_pic1.png",
      subtitle: "Aunque se recomienda que los niños no pasen más de 2 horas al día frente a las pantallas, en Latinoamérica suelen superar las 5 horas. Por eso, es ideal alternar el entretenimiento con actividades productivas, como lecciones de 1 a 1.5 horas.<br><br>Nuestros programas están diseñados teniendo esto en cuenta.",
      button: "¡Muy bien!",
    },
    6: {
      question: "En la escuela, ¿qué es lo que más disfruta tu hijo?",
      answers: [
        "Ciencias o matemáticas 🧪🔢",
        "Leer y escribir historias 📚✍️",
        "Arte, música o actividades creativas 🎨🎶",
        "Educación física o deportes 🏃‍♀️🏋️‍♂️",
        "Otro 🙂"
      ],
    },
    7: {
      question: "¿A tu hijo le gusta construir o diseñar cosas (por ejemplo, con Lego, arte, rompecabezas)?",
      answers: [
        "Sí, le encanta construir y diseñar cosas 🧩🏗️",
        "A veces, pero prefiere otras actividades 🤔",
        "No, no está muy interesado en eso 🙅‍♂️",
      ],
    },
    8: {
      question: "¿Cómo aprende o recuerda mejor tu hijo cosas nuevas?",
      answers: [
        "Viendo (aprendizaje visual) 👁️",
        "Haciendo (aprendizaje práctico) 👐",
        "Escuchando (aprendizaje auditivo) 🎧",
        "A través de la repetición y la práctica 🔄✏️"
      ],
    },
    9: {
      question:
        "¿Tu hijo tiene acceso a una laptop o PC de escritorio para estudiar?",
      answers: [
        "Sí, tiene su propio dispositivo 💻✅",
        "Sí, pero lo comparte con otras personas 🖥️👫",
        {
          answer: "No, no tiene acceso regular 🚫",
          stopAnswer: true,
        },
      ],
    },
    10: {
      question: "¿Qué tipo de actividades o pasatiempos atraen más a tu hijo?",
      answers: [
        "Deportes o baile ⚽",
        "Artes creativas 🎨🖌️",
        "Dibujo, pintura o manualidades 🧩♟️💻",
        "Videojuegos o ver videos 🎮📺",
        "Otro 🙂"
      ],
    },
    11: {
      question: "¿Cómo actúa tu hijo cuando trabaja en grupo?",
      answers: [
        "Le gusta colaborar 🤝💡",
        "Prefiere liderar 🧑‍⚖️",
        "Trabaja independientemente, pero contribuye 👤✔️",
        "Se siente tímido o incómodo 😳",
      ],
    },
    12: {
      question: "¿Qué rol suele tomar tu hijo en actividades grupales?",
      answers: [
        "Le gusta liderar y organizar 🧑‍⚖️🗂️",
        "Le gusta aportar ideas y colaborar 🤝💡",
        "Prefiere escuchar y seguir 👂🙂",
        "Intenta mediar o resolver conflictos ⚖️🕊️",
        "Se siente tímido y se queda al fondo 😳"
      ],
    },
    13: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/quiz_br_2.webp",
      subtitle: "Ofrecemos formatos de aprendizaje tanto individuales como grupales, adaptando el proceso según la edad de cada niño para que sea lo más personalizado posible.",
      button: "¡Empecemos!",
    },
    14: {
      question: "¿Tu hijo ha mostrado interés en aprender a programar?",
      answers: [
        "Sí, ya ha empezado a aprender 💻🚀",
        "Sí, tiene curiosidad, pero no lo ha intentado 🤔💡",
        "Aún no, pero tal vez se interese 🤷‍♂️",
        "No, no está interesado 🙅‍♀️"
      ],
    },
    15: {
      question: "¿Cuándo se siente más cómodo y feliz tu hijo?",
      answers: [
        "Cuando juega con amigos o familia 👫❤️",
        "Cuando explora cosas nuevas o aprende 🌟🔍",
        "Cuando crea o construye algo 🛠️✨",
        "Cuando tiene un momento 🤫📖"
      ],
    },
    16: {
      question: "¿Qué actividades o materias disfruta más tu hijo?",
      answers: [
        "Lectura o escritura 📚✍️",
        "Arte, música o teatro 🎨🎶🎭",
        "Deportes o actividades físicas 🏃‍♀️⚽",
        "Tecnología o computación 💻📱",
        "Otro 🙂"
      ],
    },
    17: {
      question: "¿A tu hijo le gusta crear cosas o hacer actividades con amigos?",
      answers: [
        "Sí, adora proyectos creativos en grupo 👫🎨",
        "A veces, depende de la actividad 🤔",
        "No, prefiere tareas individuales 👤💡"
      ],
    },
    18: {
      question: "¿Tu hijo se siente cómodo usando tecnología como computadoras, aplicaciones o tareas básicas en internet?",
      answers: [
        "Muy cómodo, la usa con frecuencia 💻✔️",
        "Realiza tareas, pero necesita ayuda 🖱️❓",
        "No está familiarizado 🚫"
      ],
    },
    19: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/fwd_freetc_latam_pic2.png",
      subtitle: "En Kodland, los estudiantes diseñan modelos 3D, crean cómics, desarrollan juegos y programan. ¡Actualmente, 30,000 niños en todo el mundo están aprendiendo con nosotros!",
      button: "¡Genial!",
    },
    20: {
      question: "¿Cómo maneja tu hijo los desafíos o problemas?",
      answers: [
        "Intenta resolverlo por sí mismo 💪🧠",
        "Pide ayuda cuando es necesario 🙋‍♀️✔️",
        "Se frustra y se rinde fácilmente 😤",
        "Ve los problemas como un reto 🕵️‍♂️"
      ],
    },
    21: {
      question: "¿Tu hijo muestra interés en crear sus propias historias o personajes?",
      answers: [
        "Adora contar historias y tiene ideas ✍️",
        "A veces, pero necesita estímulo 🤗",
        "No, no tiene mucho interés en eso 🚫",
      ],
    },
    22: {
      question: "¿Cómo maneja tu hijo las tareas que requieren atención y pensamiento lógico?",
      answers: [
        "Se concentra y resuelve problemas 🎯🧩",
        "Se desempeña con orientación 🗂️🤝",
        "Dificultad con tareas detalladas 😵‍💫",
      ],
    },
    23: {
      question: "Cuando tu hijo cuenta una historia, suele…",
      answers: [
        "Enfocarse en detalles 📝📜",
        "Ir al punto principal 🎯",
        "Añadir humor o imaginación 🤪✨",
        "Luchar por organizar pensamientos 🤔"
      ],
    },
    24: {
      question: "¿Cómo reacciona tu hijo al probar algo nuevo?",
      answers: [
        "Se lanza con entusiasmo 🎉🚀",
        "Está curioso, pero cauteloso 🤔👣",
        "Se siente nervioso y necesita apoyo 😬🤗",
        "Le encanta experimentar 🛠️🔬",
        "Se resiste a probar cosas nuevas 🙅‍♂️"
      ],
    },
    25: {
      question: "¿Tu hijo prefiere seguir instrucciones o crear sus propias ideas?",
      answers: [
        "Le gustan las instrucciones claras ✔️",
        "Prefiere ideas creativas y nuevos enfoques 🎨",
        "Le gusta una mezcla de estructura y libertad 🛠️",
        "Depende de la tarea: estructura o creatividad 🤷‍♂️"
      ],
    },
    26: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/reviews-latam.png",
      subtitle: "Padres de todo el mundo nos recomiendan. ¡Esperamos que pronto te unas a ellos! 💙",
      button: "¡Ya casi terminamos!",
    },
    27: {
      question: "¿Qué motiva a tu hijo a mantenerse enfocado en una tarea?",
      answers: [
        "Un objetivo claro o recompensa al final 🎯🏅",
        "Emoción o pasión por la tarea ✨❤️",
        "Trabajar en grupo 🤝💬",
        "Recibir motivación durante el proceso 👏😊",
        "Sentir que es un reto o una competencia 🥇🔥"
      ],
    },
    28: {
      question: "¿Qué tipo de historias o temas le gusta hablar a tu hijo?",
      answers: [
        "Ciencia, tecnología o inventos 🗺️🐉",
        "Ciencia, tecnología o invenciones 🔬💻",
        "Historias divertidas o cómicas 🤪😂",
        "Eventos reales o historia 📜🌍",
        "Historias sobre amistades o emociones ❤️👫"
      ],
    },
    29: {
      question: "¿Qué hace que tu hijo se sienta orgulloso o realizado?",
      answers: [
        "Completar una tarea desafiante 🏆🧠",
        "Ayudar a los demás o contribuir 🤝❤️",
        "Aprender algo nuevo 📚✨",
        "Recibir comentarios positivos 🥳👏",
        "Resolver un problema complicado 🔍🧩"
      ],
    },
    30: {
      title: "🎉 ¡Solo un paso más!",
      typeInfo: "congrats",
      subtitle:
        "Ayuda a tu hijo a explorar su lado creativo con programación y diseño digital.<br>🌟 Ya son más de 200.000 niños creando y aprendiendo con nosotros.",
      button: "📅 ¡Reserva una clase gratis!",
    },
    31: {
      title: "🎉 Regístrate para una clase de prueba gratuita",
      type: "one-page-contacts",
      subtitle: "¡Vamos a conocernos y mostrarte cómo funciona Kodland!<br>En la primera clase, tu hijo creará su propio minijuego y verá cómo son las actividades.<br>¡Y tú puedes acompañarlo!<br><br>👇 Completa tus datos para reservar.",
      button: "🎉 ¡Perfecto! Solo falta un paso más.",
    },
    32: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    33: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    34: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    35: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
